import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { Feature, type FeatureCollection, MultiPolygon, Polygon } from "geojson";
import { parseGeoData } from "senf-shared";
import point from "turf-point";
import polygon from "turf-polygon";

export function checkIfPointInPolygon(
  viewport: { longitude: number; latitude: number },
  polygonData: FeatureCollection | string
): boolean {
  const pt = point([viewport.longitude, viewport.latitude]);
  const geojson = parseGeoData(polygonData) as FeatureCollection;

  // Function to check if a point is in a polygon with given coordinates
  function checkPolygon(coordinates: number[][][]): boolean {
    for (const ring of coordinates) {
      // Ensure the first and last coordinates are equivalent
      if (ring.length > 1) {
        const firstCoordinate = ring[0];
        const lastCoordinate = ring[ring.length - 1];
        if (
          firstCoordinate[0] !== lastCoordinate[0] ||
          firstCoordinate[1] !== lastCoordinate[1]
        ) {
          ring.push([...firstCoordinate]);
        }
      }
      const poly = polygon([ring]);
      if (booleanPointInPolygon(pt, poly)) {
        return true;
      }
    }
    return false;
  }

  // Check if point is in any of the polygons
  for (const feature of geojson.features ?? []) {
    if (!feature.geometry) continue;

    if (feature.geometry.type === "Polygon") {
      if (checkPolygon(feature.geometry.coordinates)) {
        return true;
      }
    } else if (feature.geometry.type === "MultiPolygon") {
      // For MultiPolygon, each element in coordinates is a polygon
      for (const polygonCoords of feature.geometry.coordinates) {
        if (checkPolygon(polygonCoords)) {
          return true;
        }
      }
    }
  }

  return false;
}
